import {FocusBox} from './focus-box.component';
import {FocusTrap, createFocusTrap, Options as FocusTrapOptions} from 'focus-trap';

export class FocusBoxDomInjector {
    focusTrap: FocusTrap;

    scrollEventHandler = (): void => {
        this.focusTrap.deactivate();
    }

    constructor(
        private document: Document,
        private window: Window,
        private hostElement: HTMLDivElement,
        private focusBox: FocusBox
    ) {
        const focusTrapOptions: FocusTrapOptions = {
            onActivate: () => {
                this.window.addEventListener('scroll', this.scrollEventHandler);
            },
            initialFocus: this.focusBox.config.initialFocus,
            escapeDeactivates: true,
            clickOutsideDeactivates: true,
            returnFocusOnDeactivate: false,
            onDeactivate: () => {
                this.focusBox.unOpen();
                this.window.removeEventListener('scroll', this.scrollEventHandler);
            },
            document: this.document
        }

        this.focusTrap = createFocusTrap([this.hostElement, ...this.focusBox.config.extensions], focusTrapOptions);
    }

    open(): void {
        this.focusTrap.activate();
    }

    close(): void {
        this.focusTrap.deactivate();
    }
}